import React from 'react';
import Tabs from 'cccisd-tabs';
import { DataBrowser } from 'cccisd-laravel-assignment';

const appdefs = window.cccisd.appDefs.app;

const ViewData = () => {
    const getDataTabs = () => {
        // get plans from appdefs to determine which tabs to show
        const plans = appdefs.plans;
        const dataTabs = [];

        plans.forEach(plan => {
            dataTabs.push({
                name: plan.label,
                title: plan.label,
                content: (
                    <DataBrowser
                        key={plan.projectId + '_' + plan.name}
                        projectId={plan.projectId}
                        showAssignmentIds={[plan.youthAssignmentId, plan.caregiverAssignmentId]}
                    />
                ),
            });
        });
        return dataTabs;
    };

    return (
        <div>
            <br />
            <Tabs tabId="viewData" tabList={getDataTabs()} />
        </div>
    );
};

export default ViewData;
